module.exports = __webpack_public_path__ + "img/thumb-p5.a2cc70b6.png";